"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useFloatingContext_exports = {};
__export(useFloatingContext_exports, {
  useFloatingContext: () => useFloatingContext
});
module.exports = __toCommonJS(useFloatingContext_exports);
var import_react = require("@floating-ui/react");
var import_react2 = require("react");
const useFloatingContext = ({ open, setOpen, breakpointActive }) => (0, import_react2.useCallback)(
  (props) => {
    const floating = (0, import_react.useFloating)({
      ...props,
      open,
      onOpenChange: setOpen
    });
    const { getReferenceProps, getFloatingProps } = (0, import_react.useInteractions)([
      // useFocus(floating.context, {
      //   enabled: !breakpointActive,
      //   keyboardOnly: true,
      // }),
      (0, import_react.useRole)(floating.context, { role: "dialog" }),
      (0, import_react.useDismiss)(floating.context, {
        enabled: !breakpointActive
      })
    ]);
    return {
      ...floating,
      getReferenceProps,
      getFloatingProps
    };
  },
  [open, setOpen, breakpointActive]
);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  useFloatingContext
});
//# sourceMappingURL=useFloatingContext.js.map
